import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function VipPipCardModal({ isOpen, onClose }) {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [amount, setAmount] = useState(10);
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(API + "/vippip/initiate-creation", {
                name,
                phone,
                amount_usd: amount
            });
            if (res.data.payment_url) {
                window.location.href = res.data.payment_url;
            } else {
                toast.error("Pa jwenn lyen MonCash la.");
            }
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erè koneksyon. Eseye ankò.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-3xl w-full max-w-md overflow-hidden shadow-2xl relative">
                <div className="p-6">
                    <button onClick={onClose} className="absolute right-6 top-6 text-gray-400 hover:text-gray-900">
                        <X size={24} />
                    </button>
                    <h2 className="text-2xl font-bold mb-1">Kreye Kat VipPip</h2>
                    <p className="text-gray-500 mb-6 text-sm">Kat vityèl ou ap kreye touswit apre w fin peye ak MonCash.</p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label>Non sou kat la</Label>
                            <Input placeholder="Egz: John Doe" value={name} onChange={e => setName(e.target.value)} required />
                        </div>
                        <div className="space-y-2">
                            <Label>Telefòn</Label>
                            <Input placeholder="38000000" value={phone} onChange={e => setPhone(e.target.value)} required />
                        </div>
                        <div className="space-y-2">
                            <Label>Kantite Kòb ()</Label>
                            <Input type="number" min="5" value={amount} onChange={e => setAmount(e.target.value)} required />
                            <p className="text-xs text-gray-500 mt-1">Lajan sa a ap disponib sou kat ou a.</p>
                        </div>
                        
                        <Button type="submit" className="w-full h-12 text-lg rounded-xl mt-6" disabled={loading || !name || !phone || amount < 5}>
                            {loading ? <Loader2 className="animate-spin mr-2" /> : null}
                            {loading ? "Pasyante..." : "Peye ak MonCash"}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}